/**
 * Marks a control Guide may point at (plan
 * guide-can-walk-a-person-through-a-task-highlight, item guide-anchors;
 * docs/architecture/guide-anchors.md):
 *
 *   <OpsButton {...guideAnchor('msgraph.email.add-mail-app')} …>
 *   <Button {...guideAnchor('msgraph.setup.areas.approve', area.key)} …>
 *
 * spreads data-guide-anchor="<name>" (and data-guide-anchor-key for a keyed
 * anchor) onto the element. Only names declared in
 * shared/features/<feature>.anchors.ts render: an undeclared name, or a
 * missing or unexpected key, throws in tests and the dev server, and renders
 * no marker in a production build. The attribute changes nothing for people:
 * only the tour engine reads it. `guideAnchor()` with no name spreads nothing.
 */
import { guideAnchorAttributes } from '../../../../shared/guideAnchorRegistry'

export const GUIDE_ANCHOR_ATTRIBUTE = 'data-guide-anchor'
export const GUIDE_ANCHOR_KEY_ATTRIBUTE = 'data-guide-anchor-key'

export function guideAnchor(name, key) {
  if (name === undefined || name === null) return {}
  try {
    return guideAnchorAttributes(name, key)
  } catch (err) {
    if (!import.meta.env.PROD) throw err
    return {}
  }
}
